import { Component } from '@angular/core';

@Component({
  selector: 'app-footer-center',
  templateUrl: './footer-center.component.html',
  styleUrl: './footer-center.component.scss',
  standalone: false
})
export class FooterCenterComponent {

}
